export const Team = [
  {
    name: 'Mr. Rahi Tajzadeh',
    img: 'https://www.knowquest.net/images/RST2.jpg',
    role: 'CEO',
    linkedin: 'https://www.linkedin.com/in/tajzadeh/',
  },
  {
    name: 'Dr. Agostino Menna PhD',
    img: 'https://www.knowquest.net/images/AgostinoMenna1.jpg',
    role: 'Founder, Board Director',
    linkedin: 'https://www.linkedin.com/in/agostinomenna/',
  },
  {
    name: 'Bahareh Attari',
    img: 'https://www.knowquest.net/images/bahareh.jpg',
    role: 'Web Developer',
    linkedin: '',
  },
  {
    name: 'Ayoob Faraji',
    img: 'https://www.knowquest.net/images/Ayoob.jpg',
    role: 'Lead Web Developer',
    linkedin: 'https://www.linkedin.com/in/ayoob-faraji-291a8ba4/',
  },
  {
    name: 'Luke Guevara',
    img: 'https://www.knowquest.net/images/Luke.jpg',
    role: ' Marketing Cordinator',
    linkedin: 'https://www.linkedin.com/in/luke-guevara-7999b4170/',
  },
  {
    name: 'Lou Vescio',
    img: 'https://www.knowquest.net/images/lou.jpeg',
    role: 'Education Expert',
    linkedin: 'https://www.linkedin.com/in/louvescio/',
  },
  {
    name: 'Jiri Fiali',
    img: 'https://www.knowquest.net/images/Jiri.jpg',
    role: 'Data Security',
    linkedin: '',
  },
  {
    name: 'Amrish Manna',
    img: 'https://www.knowquest.net/images/Amrish.jpg',
    role: 'Operations',
    linkedin: 'https://www.linkedin.com/in/amrish-manna/',
  },
  {
    name: 'Neil Cosby',
    img: 'https://www.knowquest.net/images/Neil.jpg',
    role: 'Business Development',
    linkedin: 'https://www.linkedin.com/in/neil-cosby-chrl-mba-08130310/',
  },
  {
    name: 'Ron McMeeken',
    img: 'https://www.knowquest.net/images/Ron.jpg',
    role: 'Accounting, Finance',
    linkedin: 'https://www.linkedin.com/in/ron-mcmeeken-89369526/',
  },
];
export const Developer = [
  {
    name: 'Murtuza Barodawala',
    img: '',
    role: 'Software Developer',
    linkedin: 'https://www.linkedin.com/in/murtuzab786/',
  },
  {
    name: 'Rhea Christian',
    img: '',
    role: 'Software Developer',
    linkedin: 'https://www.linkedin.com/in/rheachristian/',
  },
  {
    name: 'Tushar Chavan',
    img: '',
    role: 'Full Stack Developer',
    linkedin: 'https://www.linkedin.com/in/tushar-chavan-6b310385/',
  },
  {
    name: 'Abid Khawaja',
    img: '',
    role: 'Front End Developer',
    linkedin: '',
  },
  {
    name: 'Mason DiGaudio',
    img: '',
    role: 'Full Stack Developer',
    linkedin: 'https://www.linkedin.com/in/mason-digaudio/',
  },
  {
    name: 'Zach Weller',
    img: '',
    role: 'Full Stack Developer',
    linkedin: 'https://www.linkedin.com/in/zachary-weller-3070a0257/',
  },
  {
    name: 'Jagjyot Singh',
    img: '',
    role: 'Software Developer',
    linkedin: '',
  },
  {
    name: 'Victor',
    img: '',
    role: 'Software Developer',
    linkedin: '',
  },
  {
    name: 'Jordan Tapiero',
    img: '',
    role: '',
    linkedin: 'https://www.linkedin.com/in/jordantapiero/',
  },
];
export const Lead = [
  {
    name: 'Harman Mann',
    img: '',
    role: 'Team Lead - Full Stack Developer',
    linkedin: 'https://www.linkedin.com/in/harman-s-mann/',
  },
];
export const Previous = [
  {
    name: 'Yash Mehta',
    img: '',
    role: 'Full Stack Developer',
    linkedin: 'https://www.linkedin.com/in/yashmehta76/',
  },
  {
    name: 'Vishal Gami',
    img: '',
    role: 'Full Stack Developer',
    linkedin: 'https://www.linkedin.com/in/vishalgami/',
  },
  {
    name: 'Vrushank Amin',
    img: '',
    role: 'Full Stack Developer',
    linkedin: 'https://www.linkedin.com/in/vrushank-amin/',
  },
  {
    name: 'Namrata Kaur',
    img: '',
    role: 'Database Developer',
    linkedin: 'https://www.linkedin.com/in/namratakaur/',
  },
];
